<template>
  <div class="elevation-1">
    <v-toolbar flat>
      <v-btn v-if="$is_privilege(['root', 'developer'])" flat to="/settings/settings"> Settings </v-btn>
      <v-btn v-if="$is_admin()" flat to="/settings/list_types"> List Types </v-btn>
      <v-menu offset-y v-if="$is_admin()">
        <template slot="activator" slot-scope="{ on }">
          <v-btn v-if="$is_admin()" v-on="on" flat class="pr-1" v-model="$route.path.startsWith('/settings/external_devices')"> External devices <v-icon dark>arrow_drop_down</v-icon> </v-btn>
        </template>
        <v-list>
          <v-list-tile to="/settings/external_devices/videohub">
            <v-list-tile-title>Videohub</v-list-tile-title>
          </v-list-tile>
          <v-list-tile to="/settings/external_devices/teranex">
            <v-list-tile-title>Teranex</v-list-tile-title>
          </v-list-tile>
          <v-list-tile to="/settings/external_devices/pdu">
            <v-list-tile-title>PDU</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
<!--      <v-btn v-if="$is_admin()" flat to="/settings/running_orders"> Running orders </v-btn>-->

      <v-btn v-if="!$is_admin()" flat to="/settings/profile"> Profile </v-btn>
      <v-menu offset-y v-if="$is_admin()">
        <template slot="activator" slot-scope="{ on }">
          <v-btn v-on="on" flat class="pr-1" v-model="$route.path.startsWith('/settings/profile') || $route.path.startsWith('/settings/sessions')"> Profile <v-icon dark>arrow_drop_down</v-icon> </v-btn>
        </template>
        <v-list>
          <v-list-tile to="/settings/profile">
            <v-list-tile-title>Profile</v-list-tile-title>
          </v-list-tile>
          <v-list-tile to="/settings/sessions">
            <v-list-tile-title>Sessions</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn v-if="!$is_admin()" flat to="/settings/sessions"> Sessions </v-btn>
      <v-btn v-if="$is_admin()" flat to="/settings/accounts"> Accounts </v-btn>
      <v-btn v-if="$is_admin()" flat to="/settings/groups"> Groups </v-btn>
      <v-btn v-if="$is_privilege(['root', 'developer'])" flat to="/settings/maintenance"> Maintenance </v-btn>
    </v-toolbar>
    <v-flex xs12>
      <router-view></router-view>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Settings from './settings/Settings.vue'
import ListTypes from './settings/ListTypes.vue'
import Profile from './settings/Profile.vue'
import Sessions from './settings/Sessions.vue'
import Accounts from './settings/Accounts.vue'
import Groups from './settings/Groups.vue'
import RunningOrders from './settings/RunningOrders.vue'
import Maintenance from './settings/Maintenance.vue'
import ExternalDevices from './settings/ExternalDevices.vue'

export default {
  routes: [
    {
      path: "",
      redirect: "profile"
    },
    {
      path: 'settings',
      component: Settings,
      children: Settings.routes
    },
    {
      path: 'list_types',
      component: ListTypes,
      children: ListTypes.routes
    },
    {
      path: "running_orders",
      component: RunningOrders,
      children: RunningOrders.routes
    },
    {
      path: "maintenance",
      component: Maintenance
    },
    {
      path: "external_devices",
      component: ExternalDevices,
      children: ExternalDevices.routes
    },
    {
      path: 'profile',
      name: "Profile",
      component: Profile
    },
    {
      path: 'accounts',
      component: Accounts,
      children: Accounts.routes
    },
    {
      path: 'groups',
      component: Groups,
      children: Groups.routes
    },
    {
      path: 'sessions',
      name: "Sessions",
      component: Sessions
    }
  ]
}
</script>

<style>
</style>
